(function () {
  var LANDING_KEY = 'ld_landing_page';
  var passing = false;
  var generation = 0;

  function vista() {
    var view = new URLSearchParams(location.search).get('view') || '';
    if (view === 'v2' || view === 'v2-kit') return 'v2';
    if (document.documentElement.classList.contains('ld-v2-home')) return 'v2';
    if (document.documentElement.dataset.ldVista === 'v2') return 'v2';
    return 'normal';
  }

  function landing() {
    var path = location.pathname || '/';
    var stored = '';
    try { stored = sessionStorage.getItem(LANDING_KEY) || ''; } catch (error) {}
    if (/^\/(cart|checkout|account)(\/|$)/.test(path)) return stored;
    if (!stored) {
      try { sessionStorage.setItem(LANDING_KEY, path); } catch (error) {}
      stored = path;
    }
    return stored;
  }

  function sync(options) {
    var origen = options && options.origen ? options.origen : 'tienda';
    var page = landing();
    if (!page) return Promise.resolve();
    var token = ++generation;
    var next = { landing_page: page, vista: vista(), origen: origen, ld_variant: vista() };
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (token !== generation) return null;
        var attributes = {};
        var current = cart && cart.attributes ? cart.attributes : {};
        Object.keys(current).forEach(function (key) {
          if (current[key] != null && current[key] !== '') attributes[key] = String(current[key]);
        });
        if (attributes.landing_page === next.landing_page && attributes.vista === next.vista && attributes.origen === next.origen && attributes.ld_variant === next.ld_variant) return null;
        Object.keys(next).forEach(function (key) { attributes[key] = next[key]; });
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function () {});
  }

  window.ldSaleSource = sync;

  document.addEventListener('click', function (event) {
    if (passing || !event.target.closest) return;
    var cod = event.target.closest('#_rsi-buy-now-button');
    if (!cod) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var origen = location.pathname.indexOf('/pages/arma-tu-kit') === 0 ? 'arma-tu-kit' : 'tienda';
    sync({ origen: origen }).then(function () {
      passing = true;
      cod.click();
      passing = false;
    });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); });
  else sync();
})();
